import React from "react";
import { useNavigate } from "react-router-dom";
import { useClub } from "../club/ClubContext";
import { httpClient } from "../httpClient";
import { Card, CardContent, Typography, Button, Stack } from "@mui/material";

type Template = {
  id: number;
  name: string;
  description?: string;
  rows: number;
  columns: number;
  max_points_total: number;
};

export function TrainingSelectPage() {
  const { clubId } = useClub();
  const nav = useNavigate();
  const [items, setItems] = React.useState<Template[]>([]);

  React.useEffect(() => {
    if (!clubId) return;
    (async () => {
      const { json } = await httpClient(`/api/training/templates?club_id=${clubId}&playableOnly=1`);
      setItems(json as Template[]);
    })();
  }, [clubId]);

  return (
    <Stack spacing={2} sx={{ p: 2, width: "100%", }}>
      <Typography variant="h5" fontWeight={700}>
        Training auswählen
      </Typography>

      <Stack spacing={2}>
        {items.map((t) => (
          <Card key={t.id} sx={{ borderRadius: 1 }}>
            <CardContent>
              <Typography variant="h6" fontWeight={700}>
                {t.name}
              </Typography>
              {t.description ? (
                <Typography variant="body2" sx={{ mt: 0.5, opacity: 0.8 }}>
                  {t.description}
                </Typography>
              ) : null}

              <Typography variant="caption" sx={{ display: "block", mt: 1, opacity: 0.8 }}>
                {t.columns} Spalten · {t.rows} Reihen · Max {t.max_points_total} Punkte
              </Typography>

              <Button
                variant="contained"
                sx={{ mt: 2, borderRadius: 3, py: 1.2 }}
                fullWidth
                onClick={() => nav(`/play/training/${t.id}`)}
              >
                Starten
              </Button>
            </CardContent>
          </Card>
        ))}
      </Stack>
    </Stack>
  );
}
